import styled from 'styled-components';

export const FaqQuestionContainer = styled.div`
	width: 100%;
	min-height: 6rem;

	/* border-radius: 1rem; */

	overflow: hidden;

	.question-content {
		display: flex;
		align-items: center;
		justify-content: space-between;

		min-height: 7.2rem;
		padding: 2rem 3.2rem;

		font-size: 1.6rem;
		cursor: pointer;

		span {
			font-weight: 500;
		}

		i {
			transition: 0.2s;
		}
	}

	.answer {
		display: flex;
		text-align: left;

		max-height: 0;
		height: 100%;
		padding: 0 3.2rem;

		opacity: 0;
		transition: 0.4s;

		p {
			padding: 3.2rem 0 3.6rem;
			line-height: 1.5;

			font-size: var(--text-size);

			border-top: 1px solid var(--color-gray-30);
		}

		a {
			font-weight: bold;

			&:hover {
				text-decoration: underline;
			}
		}
	}

    + .question {
        border-top: 1px solid #20202499;
    }

	&.active {
		background: var(--color-surface);

		.answer {
			max-height: 50rem;
			opacity: 1;
		}

		.question-content {
			background: var(--color-surface);

			span {
				color: #fff;
			}

			i {
				transform: rotate(180deg) !important;
			}
		}
	}
`;

export default FaqQuestionContainer;
